import UnsupervisedJobs from './UnsupervisedJobs';

export default UnsupervisedJobs;
